if (!customElements.get('card-variant-radios')) {
  customElements.define(
    'card-variant-radios',
    class CardVariantRadios extends HTMLElement {
      constructor() {
        super();
        this.variants = [];
        this.currentVariant = null;
      }

      connectedCallback() {
        try {
          const json = this.querySelector('.card-variant-json');
          if (json) this.variants = JSON.parse(json.textContent);
        } catch (e) {
          return;
        }

        this.cardWrapper = this.closest('.card-wrapper');
        if (!this.cardWrapper) return;

        this.productId = this.dataset.productId;
        this.select = this.querySelector('select');
        if (!this.select) return;

        this.select.addEventListener('change', this.onVariantChange.bind(this));

        // Set initial variant and update card to reflect it
        this.updateCurrentVariant();
        if (this.currentVariant) {
          this.updateCardImage();
          this.updateCardPrice();
          this.updateVariantInput();
          this.updateAddToCartButton();
        }
      }

      onVariantChange() {
        this.updateCurrentVariant();
        if (!this.currentVariant) return;

        this.updateCardImage();
        this.updateCardPrice();
        this.updateVariantInput();
        this.updateAddToCartButton();
      }

      updateCurrentVariant() {
        if (!this.select) return;
        const selectedValue = this.select.value;
        this.currentVariant = this.variants.find(
          (v) => v.option1 === selectedValue
        );
      }

      updateCardImage() {
        if (!this.currentVariant) return;

        const img = this.cardWrapper.querySelector(
          '[data-card-img="' + this.productId + '"]'
        );
        if (!img) return;

        const featuredImage = this.currentVariant.featured_image;
        if (!featuredImage || !featuredImage.src) return;

        const src = featuredImage.src;
        const widths = [165, 360, 533, 720, 940, 1066];
        const srcset = widths
          .filter((w) => w <= featuredImage.width)
          .map((w) => {
            return src.replace(/(\.[^.]+)$/, '_' + w + 'x$1') + ' ' + w + 'w';
          })
          .concat([src + ' ' + featuredImage.width + 'w'])
          .join(', ');

        img.srcset = srcset;
        img.src = src.replace(/(\.[^.]+)$/, '_533x$1');
        if (featuredImage.alt) img.alt = featuredImage.alt;
      }

      updateCardPrice() {
        if (!this.currentVariant) return;

        const priceEl = this.cardWrapper.querySelector(
          '[data-card-price="' + this.productId + '"] .price-item--regular'
        );
        if (!priceEl) return;

        const formatted = this.formatMoney(this.currentVariant.price);
        priceEl.textContent = formatted;
      }

      updateVariantInput() {
        if (!this.currentVariant) return;

        const input = this.cardWrapper.querySelector('input[name="id"]');
        if (!input) return;

        input.value = this.currentVariant.id;
        input.disabled = !this.currentVariant.available;
      }

      updateAddToCartButton() {
        if (!this.currentVariant) return;

        const button = this.cardWrapper.querySelector(
          '.quick-add__submit, .quick-add-isolated .quick-add__submit'
        );
        if (!button) return;

        const available = this.currentVariant.available;
        button.disabled = !available;

        const textSpan = button.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
        const soldOutSpan = button.querySelector('.sold-out-message');

        if (textSpan) {
          textSpan.classList.toggle('hidden', !available);
        }
        if (soldOutSpan) {
          soldOutSpan.classList.toggle('hidden', available);
        }
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return '$ ' + amount;
      }
    }
  );
}
